export const isAdmin = (userInfo) => {
    if (userInfo === null)
        return false
    else
        return userInfo.roles.find(rol => {
            if (rol.name == 'admin') {
                return true
            }
        });

}